import { ButtonGroup, ButtonGroupProps, Spinner } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';
import { AppButton } from './AppButton';
import { useEffect, useMemo } from 'react';

export interface FormButtonGroupProps
  extends Omit<ButtonGroupProps, 'onSubmit'> {
  disabledWhenClean?: boolean;
  onConfirm: () => any;
  onCancel: () => any;
  submitCaption?: string;
  cancelCaption?: string;
}

export const FormButtonGroup = (props: FormButtonGroupProps) => {
  const {
    onConfirm,
    onCancel,
    disabledWhenClean = true,
    submitCaption,
    cancelCaption,
    ...rest
  } = props;
  const formProps = useFormContext();
  const { formState } = formProps;

  const isValid = useMemo(
    () => Object.keys(formState.errors).length === 0,
    [formState]
  );

  const isDisabled = useMemo(
    () =>
      (!formState.isDirty && disabledWhenClean) ||
      formState.isSubmitting ||
      !isValid,
    [disabledWhenClean, formState, isValid]
  );

  useEffect(() => {
    if (!formState) {
      console.warn(`WARNING: no form state found for button group!`);
    }
    if (isDisabled) {
      console.debug('submit disabled: ', {
        formState,
        isDirty: formState.isDirty,
        isSubmitting: formState.isSubmitting,
        isValid,
        errors: formState.errors,
        disabledWhenClean,
        isDisabled,
      });
    }
  }, [disabledWhenClean, formState, isDisabled, isValid]);

  const leftIcon = (formState.isSubmitting && <Spinner />) || undefined;

  return (
    <ButtonGroup spacing={4} {...rest}>
      <AppButton
        type="submit"
        colorScheme="blue"
        variant={'solid'}
        onClick={onConfirm}
        isDisabled={isDisabled}
        leftIcon={leftIcon}
      >
        {submitCaption || 'Submit'}
      </AppButton>
      <AppButton formState={formState} type="reset" onClick={onCancel}>
        {cancelCaption || 'Cancel'}
      </AppButton>
    </ButtonGroup>
  );
};
